import i18next from 'i18next';
import { GlobalDialogs } from '../GlobalDialogs';
import api from '../../api';
import type { Core } from '@pdftron/webviewer';
import { ApryseSDK } from '../ApryseSDK';
import { ReduxUpdater } from '../ReduxUpdater';
import { RedliningActionLogger } from '../RedliningActionLogger';
import { ToastSeverity } from '../../components/General/Toast/Toast';
import { CustomHistoryManager } from '../CustomHistoryManager';
import { getSessionKey } from '../../utils';

export function isButtonPresent(_buttonName: string): boolean {
    // // ToDO: fix
    return true;
    // //   /* eslint-disable @typescript-eslint/no-explicit-any */

    // //   if (!ctx) {
    // //     return false;
    // //   }

    // //   const recursiveSearch = (item: Array<any> | string): boolean => {

    // //     if (!item) {
    // //       return false;
    // //     }

    // //     if (typeof (item) === 'string' && item === buttonName) {
    // //       return true;
    // //     }

    // //     let found = false;

    // //     if (Array.isArray(item)) {
    // //       item.forEach((child: Array<any> | string) => {
    // //         if (recursiveSearch(child)) {
    // //           found = true;
    // //         }
    // //       });
    // //     }

    // //     return found;
    // //   };

    // //   const bars = ctx.eplassContext.menuDefinitions.annotationMode.bars;
    // //   const keys = Object.keys(ctx.eplassContext.menuDefinitions.annotationMode.bars);

    // //   let included = false;
    // //   keys.forEach(key => {
    // //     if (!included) {
    // //       const bar = bars[key];
    // //       if (recursiveSearch(bar)) {
    // //         included = true;
    // //       }
    // //     }
    // //   });

    // //   return included;

    // //   /* eslint-enable @typescript-eslint/no-explicit-any */
}

export function BorderInfoToStyleString(annot: Core.Annotations.Annotation): string {
    if (!annot) {
        return 'solid';
    }

    const dashes = ApryseSDK.annotDashes(annot);
    const intensity = ApryseSDK.annotIntensity(annot);
    const style = ApryseSDK.annotStyle(annot);

    switch (style) {
        case 'dash': {
            switch (dashes) {
                case '2,2,2,2':
                    return 'dashed small';
                case '3,3,3,3':
                    return 'dashed medium';
                case '4,4,4,4':
                    return 'dashed large';
                case '4,3,2,3':
                    return 'dashed large small';
                case '8,4,4,4':
                    return 'dashed large xl';
                case '4,3,16,3':
                    return 'dashed xl medium';
            }
            break;
        }
        case 'cloudy': {
            switch (intensity) {
                case 1:
                    return 'cloudy small';
                case 2:
                case undefined:
                    return 'cloudy large';
            }
            break;
        }
    }
    return 'solid';
}

/**
 * Save document changes
 */
export async function saveDocument(): Promise<void> {
    ReduxUpdater.setSavingDocument(true);
    const file = await ApryseSDK.getDocumentData();
    const viewerKey = getSessionKey();

    const formData = new FormData();
    formData.append('viewerKey', viewerKey);
    formData.append('data', file);

    return api
        .post('pdf/save' as string, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(
            () => {
                GlobalDialogs.showNotyDebounced(
                    2.0,
                    i18next.t('success.saveDocument'),
                    ToastSeverity.Success,
                );
                ReduxUpdater.setSavingDocument(false);
                ReduxUpdater.documentSaved = true;
                CustomHistoryManager.savedTime = Date.now();
                CustomHistoryManager.savedIds = ApryseSDK.annotationManager
                    .getAnnotationsList()
                    .map(a => a.Id);

                RedliningActionLogger.appendLog('save-success');
            },
            () => {
                GlobalDialogs.showNotyDebounced(
                    2.0,
                    i18next.t('errors.saveDocument'),
                    ToastSeverity.Error,
                );
                ReduxUpdater.setSavingDocument(false);
                ReduxUpdater.documentSaved = false;

                RedliningActionLogger.appendLog('save-reject');
            },
        )
        .catch(() => {
            RedliningActionLogger.appendLog('save-error');
        });
}
